import { REQUIRED_MESSAGE } from './common';

const REQUIRED = { required: true, message: REQUIRED_MESSAGE };

export { REQUIRED };
